export default "__VITE_ASSET__87ea7d30__"